import { render, staticRenderFns } from "./SignalrUser.vue?vue&type=template&id=38573318&"
import script from "./SignalrUser.vue?vue&type=script&lang=js&"
export * from "./SignalrUser.vue?vue&type=script&lang=js&"
import style0 from "./SignalrUser.vue?vue&type=style&index=0&scopep=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports